import React from 'react';
import ChatbotCore from './ChatbotCore';

const questions = [
  { text: "Please could you talk about your early life - who was around you and where were you?", followups: 2 },
  { text: "Can you describe the deployment this book will focus on?", followups: 1 },
  { text: "What was daily life like during this deployment?", followups: 1 },
  { text: "Can you share a moment that stands out?", followups: 0 }
];

export default function FullBook() {
  return <ChatbotCore title="Full Book" baseQuestions={questions} />;
}
